import React, { Fragment } from "react";
import { Container, Row, Col } from "reactstrap";
const Footer = (props) => {
    return (
        <Fragment>
            <footer className="footer">
                <Container fluid={true}>
                    <Row>
                        <Col md="4" className="footer-copyright">
                            <h6>INFANT INDIA</h6>
                            <p>We're Fighting AIDS Together</p>
                            <p>
                                ANANDWAN - For HIV / AIDS Affected Orphans in
                                Infant India
                            </p>
                            <p>MAHER - A place for HIV Affected women</p>
                            <p>
                                NAVJEEVAN - A Rehabilitation Project of Married
                                Couples
                            </p>
                            <p>
                                <a href="about-us.html" className="more">
                                    More About Us
                                </a>
                            </p>
                        </Col>
                        <Col md="4" className="footer-copyright">
                            <h6>GET IN TOUCH</h6>
                            <p>INFANT INDIA, Anandwan</p>

                            <p>
                                <a href="https://goo.gl/maps/CEZytGR8ZyXedwPg8">
                                    <i className="fa fa-map-marker"></i>{" "}
                                    659/Infant Hill, Pali, Beed
                                </a>
                            </p>
                            <p>
                                <a href="tel:+919822456411">
                                    <i
                                        className="fa fa-mobile-phone"
                                        style={{ fontSize: 20 }}
                                    ></i>{" "}
                                    +91 9822456411
                                </a>
                            </p>
                            <p>
                                <a href="mailto:infantindiapali@gmail.com">
                                    <i className="fa fa-envelope-o"></i>{" "}
                                    infantindiapali@gmail.com
                                </a>
                            </p>
                            <p>
                                <a
                                    href="https://infantindia.org/privacy-policy.html"
                                    className="more"
                                >
                                    Privacy Policy
                                </a>
                            </p>
                            <p>
                                <a
                                    href="https://infantindia.org/terms-and-conditions.html"
                                    className="more"
                                >
                                    Terms and Conditions
                                </a>
                            </p>
                        </Col>
                        <Col md="4" className="footer-copyright">
                            <h6>JOIN US</h6>
                            <p>Want to work with us? </p>
                            <p>Get in touch with us: +91 982 245 6411</p>
                        </Col>
                    </Row>
                </Container>
            </footer>
            <div className="footer-bottom">
                <Container fluid={true}>
                    <Row>
                        <Col md="12" className="text-center">
                            <p>
                                © 2021 All Rights Reserved To INFANT INDIA. |
                                Powered by{" "}
                                <a
                                    href="https://techx.ratnanjali.com"
                                    title="Ratnanjali TechX"
                                >
                                    Ratnanjali TechX
                                </a>
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>
        </Fragment>
    );
};

export default Footer;
